import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import request from 'superagent';

import Arrow from 'shared-vectors/icons/GalleryArrowSml';
import { Icon } from 'shared-vectors';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import Card from './components/Card';

import './style.scss';

const NewGeoReach = ({
  visible,
  setRef,
  position,
  apireq = null,
}) => {
  const [list, setList] = useState([]);
  const apireqRef = useRef(null);
  const [trackVB, setTrackVB] = useState(true);
  const slider = useRef(null);
  const [slideState, setSlideState] = useState({
    current: 0,
    coords: 0,
  });

  useEffect(() => {
    const fetchGR = async () => { 
      const [srpquery] = apireq?.query || [];
      if (srpquery && Object.keys(srpquery).length) {
        const { where, filters } = srpquery;

        const query = {
          where: where || [],
          filters: filters || {},
        };

        if (filters['transaction.type'] !== 'vendita') return;

        try {
          const proxy = await request.post('/portal-srp/api/v1/search/georeach')
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .withCredentials()
          .send({ query });

          const { body: { items } } = proxy;
          if (items && items.length > 0) {
            trackGTMEvents({
              action: 'loadModuleGeoreach',
            }, {
              paEventType: 'self_promotion.impression',
              paAdditionalCdimension: {
                cust_visible_content: [`moduleAllowed:Georeach`],
                cust_page_visible_content: `moduleAllowed:Georeach`,
                onsitead_type: 'Self promotion',
              },
              excludeGA4: true,
            }, true);
            setList(items);
          }
        } catch (error) {
          console.error('Error fetching georeach data:', error);
        }
      }
    };

    if (JSON.stringify(apireq?.query || {}) !== JSON.stringify(apireqRef?.current?.query || {})) {
      fetchGR();
      apireqRef.current = apireq;
    }
  }, [apireq, apireqRef]);

  useEffect(() => {
    setRef(slider.current);
  }, [slider, setRef]);

  useEffect(() => {
    if (visible && list.length) {
      trackGTMEvents({
        action: 'viewModuleGeoreach',
      }, {
        paEventType: 'self_promotion.impression',
        paAdditionalCdimension: {
          cust_visible_content: [`moduleGeoreach:${list.length}`],
          cust_page_visible_content: `moduleGeoreach:${list.length}`,          
          onsitead_type: 'Self promotion',
        },
      }, true);
      setTrackVB(false);
    }
  }, []);

  useEffect(() => {
    if (visible && trackVB && list.length) {
      trackGTMEvents({
        action: 'viewModuleGeoreach',
      }, {
        paEventType: 'self_promotion.impression',
        paAdditionalCdimension: {
          cust_visible_content: [`moduleGeoreach:${list.length}`],
          cust_page_visible_content: `moduleGeoreach:${list.length}`,
          onsitead_type: 'Self promotion',
        },
      }, true);
      setTrackVB(false);
    }
  }, [visible, trackVB, list]);

  const prevSlide = () => {
    const { current, coords } = slideState;
    const newCurrent = current - 1;

    let newCoords = newCurrent * 566;
    if (newCurrent === list.length - 1) {
      newCoords = coords - ((566 + 550) - slider.current.clientWidth);
    }
    setSlideState({
      current: newCurrent,
      coords: newCoords,
    });    
  };

  const nextSlide = () => {
    const { current, coords } = slideState;
    const newCurrent = current + 1;
    
    let newCoords = newCurrent * 566;
    if (newCurrent === list.length) {
      newCoords = coords + ((566 + 550) - slider.current.clientWidth);
    }

    setSlideState({
      current: newCurrent,
      coords: newCoords,
    });
  };
  
  return (
    <div ref={slider} className={`${list.length > 0 ? 'srpGReach' : ''} is-rel`} role={list.length > 0 ? 'region' : null}>
      {list.length > 0 ? (
        <>
          <p role="heading" aria-level="3" className="ml--m pb--s tp-s--s tp-w--l c-txt--f0">
            Nuove costruzioni nei dintorni
          </p>
          <Grid
            style={{ width: `${(list.length + 1) * 566}px`, transform: `translate(-${slideState.coords}px, 0)` }}
            className="srpGReach__list"
            noWrap
            role="list"
          >
            {list.map((project, index) => <Card key={project.id} project={project} visible={visible} index={index} listLength={list.length} />)}
            <GridItem
              behavior="no-shrink"
              className={`srpGReach__list__item srpGReach__list__ph${visible ? ' wi' : ''} p--m c-bg--w b--s is-rel`}
            >
              <p className="srpGReach__list__ph--tit pb--s tp-s--l tp-w--l c-txt--f0">Lasciati incuriosire dalle case nuove della tua zona!</p>
              <p className="srpGReach__list__ph--p tp-s--s tp-w--s c-txt--f5">Dai un’occhiata alle case in costruzione nei comuni vicini a quello che hai impostato nella tua ricerca.</p>
            </GridItem>
          </Grid>
          {slideState.current > 0 && (
            <button
              type="button"
              className="srpGReach__arrows mr--s c-txt--secondary b--0 b-r--pill is-clickable"
              onClick={prevSlide}
              aria-label="Nuove costruzioni precedenti"
            >
              <Icon name={Arrow} width="13px" height="13px" />
            </button>
          )}
          {slideState.current < list.length && (
            <button
              type="button"
              className="srpGReach__arrows right c-txt--secondary b--0 b-r--pill is-clickable"
              onClick={nextSlide}
              aria-label="Nuove costruzioni successive"
            >
              <Icon name={Arrow} width="13px" height="13px" className="rotate--180" />
            </button>
          )}
        </>
      ) : null}
    </div>
  );
};

export default NewGeoReach;

NewGeoReach.propTypes = {
  list: PropTypes.instanceOf(Array),
  visible: PropTypes.bool,
  setRef: PropTypes.func,
  position: PropTypes.number,
};

NewGeoReach.defaultProps = {
  list: null,
  visible: false,
  setRef: () => {},
  position: 0,
};
